var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.4 198.4",
    style: {
      enableBackground: "new 0 0 198.4 198.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D64AF;}\r\n\t.st1{fill:#00A4D6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,107.9c0,0,4.4-41.5,38.3-76.8c0,0,47-48.3,89.7-7.8c0,0-8.5-5.2-30.8,4.2c0,0-66.5,31.7-67.6,118 C79.3,145.4,64.4,133.3,49.8,107.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.1,39c0.4,0.3,9.3-13.8,23.1-22.1c0,0-40.7-27.8-57.9,3.5C41.3,20.4,57.2,24.1,76.1,39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.8,8.3c0,0-35.8,24-3.8,96.8c0,0,28.9,66.7,98.3,71.6c0,0-37,33.3-82.7,1.6c0,0-52.4-33.1-59-96.8 C0.5,81.5-8.4,24.9,47.8,8.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.3,71.3c0,0,12.4-18.2,24.5-27.9c0,0,20.1,28.3,25.1,54.1c0,0-12.2,25.3-28.9,41.6 C126,139.1,123.1,100.8,105.3,71.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.1,26.3c0,0,27.3-10,33.8,33c0,0,9.4,64.3-51.8,113.9c0,0-22.3-1.4-40.9-11.2c0,0,38.5-26.9,52.4-62.8 C158.4,97.3,176.6,55.5,164.1,26.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3cc052d53d911dc8cb1b5e50c92aa0d8.svg";
export { ForwardRef as ReactComponent };